import Checkbox from '@/components/Checkbox'
import type { ReminderCard as ReminderCardProps } from '@/shared/api-generated-types'
import dayjs from 'dayjs'
import { ChangeEvent } from 'react'

interface Props extends ReminderCardProps {
  isSubscribed: boolean
  handleOnClick: (event: ChangeEvent<HTMLInputElement>) => void
}

const ReminderCard = ({ isSubscribed, handleOnClick, ...props }: Props): JSX.Element => {
  return (
    <div className="flex flex-col w-[450px] xl:w-full gap-2 mb-2 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
      <div className="text-lg font-bold leading-[1rem] tracking-tight text-gray-900 dark:text-white mt-1 lg:mt-0">
        {props.title}
      </div>
      <div className="text-sm">{props.description}</div>
      <div className="flex">
        <Checkbox
          flush="left"
          label={`Remind me on ${dayjs(props.date).format('YYYY-MM-DD')}`}
          name={props.title}
          value={props.category}
          defaultChecked={isSubscribed}
          onChange={(event) => handleOnClick(event)}
          className="text-gray-400"
        />
      </div>
    </div>
  )
}
export default ReminderCard
